import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

export default {
  getCompanies($) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/admin/companies", {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getCompanyUsers($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/admin/companies/${id}/connections`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getPendingInvitations($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/account/admin/companies/${id}/pending_invitations`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  getExtendPlan($, id) {
    return new Promise((resolve, reject) => {
      HTTP.get(`payments/extend_period/${id}`, {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  inviteMember($, id, invitees) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/account/admin/companies/${id}/invite`, invitees)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },

  /**
   * Enables to update the status of the selected company
   * @param {*} $
   * @param {*} id user's id
   * @param {*} data which contains {is_active: true/false}
   * @returns the user updated
   */
  updateUserStatus($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/account/admin/user/${id}/status`, data)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          return reject(error)
        })
    })
  },
  /**
   *
   * @param {*} $
   * @returns list of users that hasnt been validated by the admin
   */
  getPendingValidations($) {
    return new Promise((resolve, reject) => {
      HTTP.get("/account/admin/validations", {})
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  validateUser($, id, data) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/account/admin/validations/${id}`, data)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  }
}
